import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MiscColorWheelIcon, Plus } from "@air/next-icons";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const CustomColorPickerToggle = /*#__PURE__*/ memo((param)=>{
    let { className, onClick, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("button", {
        className: tailwindMerge("relative flex h-6 items-center gap-1 rounded-24 border border-grey-5 px-1 uppercase ring-0 transition-colors data-[selected=true]:border-grey-10 data-[selected=true]:ring-1 data-[selected=true]:ring-grey-10 hover:bg-grey-4 data-[selected=true]:hover:bg-grey-4", className),
        "data-testid": "CUSTOM_COLOR_PICKER_BUTTON",
        onClick: onClick,
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx(MiscColorWheelIcon, {
                className: "size-4"
            }),
            /*#__PURE__*/ _jsx(Plus, {
                className: "size-3"
            })
        ]
    });
});
CustomColorPickerToggle.displayName = "CustomColorPickerToggle";
